document.addEventListener("DOMContentLoaded", function(){

  const collection_grid = document.querySelector('.js-campaign-collection-grid');
  const banners = document.querySelectorAll('.js-campaign-collection-banner');
  var grid_cells = collection_grid?.dataset.pageSize;
  var grid_rows = grid_cells/2;

  var desktop = false;
  var e = window, 
      a = 'inner';
  if (!('innerWidth' in window )) {
      a = 'client';
      e = document.documentElement || document.body;
  }
  if ( e[ a+'Width' ] >= 1024 ) {
    desktop =  true;
    grid_rows = grid_cells/3;
  }

  // Trigger Inquire
  const triggerInquire = () => {
    document.querySelector(".js-product-inquire-modal-open")?.click();
  }

  const triggerInquireButton = document.querySelector(".custom-atelier__popup");

  triggerInquireButton?.addEventListener('click', triggerInquire);

  // Filter and Sort dropdowns
  const filter_sort_buttons = document.querySelectorAll('.js-filter-sort-button');
  filter_sort_buttons.forEach((elem) => {
    elem.addEventListener('click', (e) => {
      elem.classList.toggle('filter-sort-button--open');
      let container = elem.nextElementSibling;
      if (container.style.maxHeight) {
        container.style.maxHeight = null;
      } else {
        container.style.maxHeight = container.scrollHeight + 'px';
      }
    });
  });

  const filter_buttons = document.querySelectorAll('.js-collection-filter');
  filter_buttons.forEach((elem) => {
    elem.addEventListener('click', (e) => {
      let filter = elem.dataset.filter;
      var status_collection_grid = document.querySelector('.js-collection-filters'); 
      if (filter === 'ready-to-ship') {
        collection_grid.classList.add('campaign-collection-grid--ready-to-ship');
        status_collection_grid.setAttribute('status', 'Active');
      } else {
        collection_grid.classList.remove('campaign-collection-grid--ready-to-ship');
        status_collection_grid.removeAttribute('status');
      }
      let button = elem.closest('.js-collection-filters').querySelector('.js-filter-sort-button');
      button.classList.remove('filter-sort-button--open');
      button.nextElementSibling.style.maxHeight = null;
    });
  });

  if (banners.length > 0) {
    let banner_frag = document.createDocumentFragment();
  
    for (let i = 0, limit = banners.length; i < limit; i++) {
      let banner = banners[i];
      let row_number = banner.dataset.row;
      let styles = `grid-row: ${row_number} / span 1;`;
      banner.setAttribute('style', styles);
      banner_frag.appendChild(banner);

      // if (row_number > grid_rows) {
      //   let styles = `grid-row: ${row_number} / span 1;`;
      //   banner.setAttribute('style', styles);
      //   banner_frag.appendChild(banner);
      // }
    }
  
    collection_grid.appendChild(banner_frag);
  }

  // function addCollectionBanners() {
  //   let banner_frag = document.createDocumentFragment();
  
  //   for (let i = 0, limit = banners.length; i < limit; i++) {
  //     let banner = banners[i];
  //     let row_number = banner.dataset.row;

  //     if (row_number > grid_rows) {
  //       let styles = `grid-row: ${row_number} / span 1;`;
  //       banner.setAttribute('style', styles);
  //       banner_frag.appendChild(banner);
  //     }
  //   }
  
  //   collection_grid.appendChild(banner_frag);
  // }

  // Collection load more observer
  const collection_sentinel = document.querySelector('.js-collection-load-more-sentinel');

  if (collection_sentinel) {
    var collection_data = {
      current_page: collection_sentinel.dataset.currentPage,
      next_page: collection_sentinel.dataset.nextPage,
      total_pages: collection_sentinel.dataset.totalPages
    };
  
    console.log(collection_data.next_page);
  
    const load_more_observer = new IntersectionObserver(entries => {
      // Loop over the entries
      entries.forEach(entry => {
        // If the element is visible
        if (entry.isIntersecting) {
  
          console.log('time to load');
          // load_more_observer.disconnect();
          load_more_observer.unobserve(collection_sentinel);
          collection_data.current_page++;
          collection_data.next_page = collection_data.next_page.replace(/page=[0-9]+/,`page=${collection_data.current_page}`);
  
          var headers = JSON.parse(
            JSON.stringify({
              credentials: 'same-origin',
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'text/html;'
              }
            })
          );
          var request = {
              method: 'GET',
              headers: headers
          };
          fetch(collection_data.next_page, request)
          .then((response) => {
            if (!response.ok) {
              throw Error(response.statusText);
            }
            console.log('response',response);
            return response.text();
          })
          .then((data) => {
            // console.log('data', data);
            var parser = new DOMParser();
            var page = parser.parseFromString(data, 'text/html');
            let new_products = page.querySelectorAll('.js-collection-product');
  
            console.log(new_products);
            
            let doc_frag = document.createDocumentFragment();
            for (let i = 0, limit = new_products.length; i < limit; i++) {
              doc_frag.append(new_products[i]);
            }
            collection_grid.append(doc_frag);
  
            if(collection_data.current_page < collection_data.total_pages) {
              load_more_observer.observe(collection_sentinel);
            } else {
              load_more_observer.disconnect();
              collection_sentinel.classList.add('hidden');
            }
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        }
      });
    });
  
    load_more_observer.observe(collection_sentinel);
  }

  if (document.querySelector('.js-product-inquire-modal')) {
    const inquire_modal = {nodes: {}}
    inquire_modal.nodes.modal = document.querySelector('.js-product-inquire-modal');
    inquire_modal.nodes.inner = document.querySelector('.js-product-inquire-modal-inner');
    inquire_modal.nodes.overlay = document.querySelector('.js-product-inquire-modal-overlay');
    inquire_modal.nodes.open = document.querySelector('.js-product-inquire-modal-open');
    inquire_modal.nodes.close = document.querySelector('.js-product-inquire-modal-close');
    inquire_modal.nodes.form = document.querySelector('.js-product-inquire-form');
    inquire_modal.nodes.submit = document.querySelector('.js-product-inquire-submit');
    inquire_modal.nodes.success = document.querySelector('.js-product-inquire-success');
    inquire_modal.nodes.error = document.querySelector('.js-product-inquire-error');
  
    inquire_modal.toggleModal = function(modal) {
      if (modal.classList.contains('hidden')) {
        window.requestAnimationFrame(() => {
          document.body.classList.add('prevent-scroll');
          modal.classList.add('opacity-0');
          modal.classList.remove('hidden');
          // inquire_modal.nodes.inner.classList.add('product-inquire-modal__inner--right');
  
          window.requestAnimationFrame(() => {
            modal.classList.remove('opacity-0');
            inquire_modal.nodes.submit.disabled = false;
            // inquire_modal.nodes.inner.classList.remove('product-inquire-modal__inner--right');
          });
        });
      } else {
        modal.addEventListener('transitionend', () => {
          modal.classList.add('hidden');
        }, {once: true});
        document.body.classList.remove('prevent-scroll');
        inquire_modal.nodes.submit.disabled = true;
        window.requestAnimationFrame(() => {
          modal.classList.add('opacity-0');
        });
      }
    }
  
    inquire_modal.nodes.open.addEventListener('click', (e) => {
      inquire_modal.toggleModal(inquire_modal.nodes.modal);
    });
    inquire_modal.nodes.close.addEventListener('click', (e) => {
      inquire_modal.toggleModal(inquire_modal.nodes.modal);
    });
    inquire_modal.nodes.overlay.addEventListener('click', (e) => {
      inquire_modal.toggleModal(inquire_modal.nodes.modal);
    });
  
    // inquire_modal.nodes.submit.addEventListener('click', (e) => {
    //   e.preventDefault();
  
    //   var form = inquire_modal.nodes.form.cloneNode(true);
  
    //   // Post data using the Fetch API
    //   fetch(form.action, {
    //       method: form.method,
    //       body: new FormData(form),
    //   })
    //   .then((response) => {
    //     if (!response.ok) {
    //       throw Error(response.status);
    //     }
    //     // if (response.url.includes('challenge')) {
    //     //   console.log('response',response, response.url);
    //     //   alert('Something has gone wrong, please try reloading the page and sending your message again, or contact us at info@azleejewelry.com');
    //     //   throw Error(response.status);
    //     // }
    //     return response.text();
    //   })
    //   .then((data) => {
    //     console.log(data);
  
    //     inquire_modal.nodes.form.addEventListener('transitionend', () => {
    //       inquire_modal.nodes.form.addEventListener('transitionend', () => {
    //         inquire_modal.nodes.form.classList.add('hidden');
    //       }, {once: true});
    
    //       inquire_modal.nodes.form.style.height = '0px';
    //       inquire_modal.nodes.success.classList.remove('hidden');
    //     }, {once: true});
  
    //     window.requestAnimationFrame(() => {
    //       inquire_modal.nodes.form.classList.add('opacity-0');
    //     });
    //   });
    // });
  }
});